// extracted by mini-css-extract-plugin
export default {"payme-handle-input":"payme-handle-input_payme-handle-input__VyOa0"};